const RoutesSsp = [
  {
    path: '/administration/overview/newSystem',
    name: 'newSystem',
    component: () => import('../../components/renderer/NewSystemSspRenderer.vue'),
  },
  {
    path: '/administration/data/importOverview',
    name: 'importOverview',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/data/dataloggerSearch',
    name: 'dataloggerSearch',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/data/reportsV1',
    name: 'reportsV1',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/management/contractOverview',
    name: 'contractOverview',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/overview/administration/new',
    name: 'newAdministration',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/user/userGroups',
    name: 'userGroups',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
];

export default RoutesSsp;
